import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getAllEMIsForWorkshop } from "../../Api/Api";
import { useWorkshop } from "../Common/WorkshopContext";
import Pagination from "../Pagination/Pagination";
import { useNotification } from "../Notification/NotificationContext";
import {Link} from "react-router-dom";

const PendingEMIList = () => {
    const { workshopId } = useWorkshop();
    const [emis, setEmis] = useState([]);
    const [status, setStatus] = useState("ALL");
    const [selectedMonth, setSelectedMonth] = useState(new Date());
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const pageSize = 20;
    const { showNotification } = useNotification();

    useEffect(() => {
        fetchEmis(currentPage);
    }, [currentPage, status, selectedMonth]);

    const fetchEmis = async (page) => {
        setLoading(true);
        const year = selectedMonth.getFullYear();
        const month = selectedMonth.getMonth() + 1;

        try {
            const response = await getAllEMIsForWorkshop(workshopId, pageSize, page, status, year, month);
            setEmis(response.data.content);
            setTotalPages(response.data.totalPages);
        } catch (error) {
            showNotification(error.message, "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="mt-6 max-w-screen-xl mx-auto">
            <div className="bg-white shadow-lg rounded-2xl overflow-hidden">
                <div className="bg-teal-500 text-white p-4 flex flex-col md:flex-row md:justify-between md:items-center gap-4 rounded-t-2xl">
                    <h2 className="text-xl font-semibold">Pending EMIs</h2>
                    <div className="flex items-center gap-4">
                        <select
                            className="border-none px-3 py-2 rounded-md focus:ring-2 focus:ring-teal-400 bg-white text-gray-800 shadow-sm"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                        >
                            <option value="ALL">All</option>
                            {/*<option value="UNPAID">Unpaid</option>*/}
                            <option value="PARTIALLY_PAID">PARTIALLY PAID</option>
                            <option value="PAID">Paid</option>
                            <option value="PENDING">Pending</option>
                            <option value="OVERDUE">Overdue</option>
                        </select>

                        <DatePicker
                            selected={selectedMonth}
                            onChange={(date) => setSelectedMonth(date)}
                            dateFormat="MMMM yyyy"
                            showMonthYearPicker
                            className="px-3 py-2 rounded-md border border-gray-300 shadow-sm text-gray-800"
                        />
                    </div>
                </div>

                <div className="p-6">
                    {loading ? (
                        <div className="flex justify-center items-center">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-400"></div>
                        </div>
                    ) : (
                        <>
                            <div className="overflow-x-auto shadow-md rounded-lg">
                                <table className="min-w-full bg-white">
                                    <thead className="bg-gray-100 text-gray-800">
                                    <tr>
                                        <th className="p-2 text-center">EMI ID</th>
                                        <th className="p-2 text-left">Customer</th>
                                        <th className="p-2 text-left">Amount</th>
                                        <th className="p-2 text-left">Penalty</th>
                                        <th className="p-2 text-left">Total Due</th>
                                        <th className="p-2 text-left">DPD</th>
                                        <th className="p-2 text-left">Status</th>
                                        <th className="p-2 text-left">Due Date</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {emis.map((emi) => (
                                        <tr key={emi.id} className="odd:bg-gray-50 even:bg-white border-b hover:bg-gray-100">
                                            <td className="p-2 text-center">{emi.id}</td>
                                            <td className="p-2 hover:underline">
                                                <Link to={`/customers/${emi.loan.customer.id}/workshops/${workshopId}/profile`}>{emi.loan.customer.name}</Link>
                                            </td>
                                            <td className="p-2">&#x20B9; {emi.amount || 0}</td>
                                            <td className="p-2">&#x20B9; {emi.penaltyAmount || 0}</td>
                                            <td className="p-2">&#x20B9; {(emi.penaltyAmount + emi.amount).toFixed(2) || 0 }</td>
                                            <td className="p-2">{emi.daysLate}</td>
                                            <td className="p-2">
                                                    <span className={`px-2 py-1 text-sm rounded-md text-white ${
                                                        emi.status === "PAID" ? "bg-green-500" :
                                                            emi.status === "OVERDUE" ? "bg-red-500" : "bg-yellow-500"}`}>
                                                        {emi.status}
                                                    </span>
                                            </td>
                                            <td className="p-2">{new Date(emi.dueDate).toLocaleDateString()}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className="p-4 bg-gray-50 rounded-b-2xl shadow-inner flex justify-start">
                                <Pagination
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    onPageChange={setCurrentPage}
                                />
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PendingEMIList;
